import { render, staticRenderFns } from "./LearningPaths.vue?vue&type=template&id=1156282c&"
import script from "./LearningPaths.vue?vue&type=script&lang=js&"
export * from "./LearningPaths.vue?vue&type=script&lang=js&"
import style0 from "./LearningPaths.vue?vue&type=style&index=0&id=1156282c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports